export default __webpack_public_path__ + "static/media/OGOni.2af10e85.webp";